import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthLoadingComponent } from './oauth-loading.component';
import {LottieModule} from 'ngx-lottie'
import player from 'lottie-web';

// Note we need a seperate function as it's required
// by the AOT compiler.
export function playerFactory(){
  return player
}

@NgModule({
  declarations: [
    OauthLoadingComponent
  ],
  imports: [
    CommonModule,
    LottieModule.forRoot({player: playerFactory})
  ],
  exports:[OauthLoadingComponent]
})
export class OauthLoadingModule { }
